import $ from 'jquery';

let accordionBlock = $('.accordion-item ');
let accordionHiddenElement = $('.accordion-item > .accordion-item__hidden');
let accordionShownElement = $('.accordion-item > .accordion-item__shown');

accordionShownElement.click(function () {
  if ($(this).parent().hasClass('accordion-item_open')) {
    accordionHiddenElement.slideUp(300);
    accordionBlock.removeClass('accordion-item_open');
    return false;
  } else {
    accordionHiddenElement.slideUp(300);
    $(this).parent().siblings().removeClass('accordion-item_open');
    $(this).next().slideDown(300);
    $(this).parent().addClass('accordion-item_open');
  }
});
